export const TemplatedNotificationRedirectTypeEnum = Object.freeze({
  CATEGORY: 'category',
  CHANNEL: 'channel',
  PRODUCT: 'product',
  SHOP: 'shop',
  DEFAULT: 'default',
});
